module.exports = __webpack_public_path__ + "img/box-incident.5d7ead5e.png";